import { Router, NavigationEnd } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";

import { EnderecoService } from "./../_shared/endereco/endereco.service";
import { Pessoa } from "./../_shared/pessoa/pessoa";
import { PessoaService } from "./../_shared/pessoa/pessoa.service";
import { Pais } from "./../_shared/endereco/pais";
import { Cidade } from "./../_shared/endereco/cidade";
import { Estado } from "./../_shared/endereco/estado";
import { ProcessoService } from "../_shared/processo/processo.service";
import Swal from "sweetalert2";
import { CandidatoService } from "../_shared/candidato/candidato.service";
import { Candidato } from "../_shared/candidato/candidato";
import { SessionService } from "../_shared/session/session.service";
import { DeferObservable } from "rxjs/observable/DeferObservable";

@Component({
  selector: "app-endereco",
  templateUrl: "./endereco.component.html",
  styleUrls: ["./endereco.component.css"],
})
export class EnderecoComponent implements OnInit {
  public pessoa = new Pessoa();
  public formulario: FormGroup;

  public paises: Pais[];
  public estados: Estado[];
  public cidades: Cidade[];

  public pais_selecionado = "Selecione um País *";
  public estado_selecionado = "UF *";
  public cidade_selecionado = "Selecione uma Cidade *";

  public pes_end_cep_placeholder = "CEP *";
  public pes_end_cep_classe: string;
  public pes_end_rua_placeholder = "Rua *";
  public pes_end_rua_classe: string;
  public pes_end_num_placeholder = "Numero *";
  public pes_end_num_classe: string;
  public pes_end_bai_placeholder = "Bairro *";
  public pes_end_bai_classe: string;
  public pes_end_cpl_placeholder = "Complemento";
  public pes_end_cpl_classe: string;
  public pes_end_cid_placeholder = "Cidade *";
  public pes_end_cid_classe: string;
  public pes_end_cep_mask = [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
  ];
  public pais_classe: string;
  public estado_classe: string;
  public cidade_classe: string;

  constructor(
    private enderecoService: EnderecoService,
    private processoService: ProcessoService,
    private SessionService: SessionService,
    private CandidatoService: CandidatoService,
    private router: Router,
    private pessoaService: PessoaService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.pessoa = this.pessoaService.getPessoa();

    this.enderecoService.getPaises().subscribe(
      (paises) => this.atualizaCamposPais(paises),
      (err) => err
    );
  }

  consultaCEP(cep) {
    cep = cep.replace(/\D/g, "");
    if (cep !== "") {
      const validacep = /^[0-9]{8}$/;
      if (validacep.test(cep)) {
        this.enderecoService.consultaCEP(cep).subscribe(
          (dados) => this.atribuiEnderecoPessoa(dados),
          (error) => (this.pes_end_cep_classe = "classWarning")
        );
      }
    }
  }

  atribuiEnderecoPessoa(data) {
    const cep = data.SdtDvCep.shift();
    if (cep.DVCidCod != 0) {
      this.pessoa.pes_end_bai = cep.CEPBairro;
      this.pessoa.pes_end_cid = cep.CEPCidade;
      this.pessoa.pes_end_rua = cep.CEPEndereco;
      this.pessoa.pes_end_uf = cep.CEPUF;
      this.pessoa.pais_cod = cep.DVPaisCod;
      this.pessoa.uf_cod = cep.DVUFCod;
      this.pessoa.cid_cod_end = cep.DVCidCod;

      this.selecionaPais(cep.DVPaisCod);
    } else {
      this.pessoa.pes_end_bai = "";
      this.pessoa.pes_end_cid = "";
      this.pessoa.pes_end_uf = "";
      this.pessoa.pes_end_rua = "";
      this.pessoa.pais_cod = null;
      this.pessoa.uf_cod = null;
      this.pessoa.cid_cod_end = null;

      this.pais_selecionado = "Selecione um País *";
      this.estado_selecionado = "UF *";
      this.cidade_selecionado = "Selecione uma Cidade *";
    }
  }

  removeClaseError() {
    this.pes_end_bai_classe = "";
    this.pes_end_cep_classe = "";
    this.pes_end_cid_classe = "";
    this.pes_end_cpl_classe = "";
    this.pes_end_rua_classe = "";
    this.pes_end_num_classe = "";
    this.pais_classe = "";
    this.estado_classe = "";
    this.cidade_classe = "";
  }

  trataPasso() {
    this.removeClaseError();

    this.formulario = new FormGroup({
      pes_end_cep: new FormControl(
        this.pessoa.pes_end_cep,
        Validators.required
      ),
      pes_end_rua: new FormControl(
        this.pessoa.pes_end_rua,
        Validators.required
      ),
      pes_end_num: new FormControl(
        this.pessoa.pes_end_num,
        Validators.required
      ),
      pes_end_bai: new FormControl(
        this.pessoa.pes_end_bai,
        Validators.required
      ),
      pais_cod: new FormControl(this.pessoa.pais_cod, Validators.required),
      uf_cod: new FormControl(this.pessoa.uf_cod, Validators.required),
      cid_cod_end: new FormControl(
        this.pessoa.cid_cod_end,
        Validators.required
      ),
    });

    if (this.formulario.status === "INVALID") {
      this.validForm("pes_end_cep", "CEP");

      this.validForm("pes_end_rua", "Rua");

      this.validForm("pes_end_num", "Número");

      this.validForm("pes_end_bai", "Bairro");

      if (this.formulario.controls.pais_cod.errors) {
        this.pais_selecionado = "País é obrigatório";
        this.pais_classe = "classWarning";
      }

      if (this.formulario.controls.uf_cod.errors) {
        this.estado_selecionado = "UF";
        this.estado_classe = "classWarning";
      }

      if (this.formulario.controls.cid_cod_end.errors) {
        this.cidade_selecionado = "Cidade é obrigatório";
        this.cidade_classe = "classWarning";
      }
    } else {
      this.pessoaService.salvaPessoa(this.pessoa).subscribe(
        (data) => this.proximo(),
        (error) => {
          if (error.errors) {
            this.trataErroWs(error.errors);
          } else {
            throw new Error();
          }
        }
      );
    }
  }

  trataErroWs(errors) {
    Object.keys(errors).forEach((element) => {
      this[element + "_placeholder"] = errors[element][0];
      this.pessoa[element] = "";
      this[element + "_classe"] = "classErro";
    });
  }

  redirecionar() {
    if (this.processoService.checkAbrirPaginaDocumentos()) {
      this.CandidatoService.getTodosDocumentos().subscribe(
        (documentosCandidato) => {
          this.CandidatoService.setDocumentosCandidato(documentosCandidato);
          this.router.navigate(["/pergunta-documentos"]);
        },
        (err) => err
      );
    } else if (this.processoService.getMatriculaRedirecionamento()) {
      this.router.navigate(["/mensagem-final-matricula-online"]);
    } else {
      this.router.navigate(["/mensagem-final"]);
    }
  }

  proximo() {
    const cursoSel = JSON.parse(
      this.SessionService.getValor("cursoSelecionado")
    );

    this.pessoaService.setPessoa(this.pessoa);
    this.processoService
      .validaRegrasBolsa({
        PrcOfeSeq: cursoSel.PrcOfeSeq,
        Vinculo: false,
        CidadeMoradia: true,
      })
      .subscribe((response) => {
        if (response.PtcTipMsgDes) {
          Swal({
            width: 500,
            title: "Atenção",
            text: response.PtcTipMsgDes,
            type: "warning",
          });

          return;
        }

        if (this.processoService.checkAbrirPaginaEnsinoMedio()) {
          this.router.navigate(["/ensino-medio"]);
        } else {
          this.CandidatoService.salvaCandidato(
            "",
            "01/01/0001",
            "0",
            0
          ).subscribe(
            (data) => {
              let candidato = this.CandidatoService.getCandidato();

              candidato.PrcCdtCod = Number(data.SdtPrcCandidato.PrcCdtCod);
              candidato.ensino = null;
              candidato.conclusao = null;
              candidato.concluinte = true;

              this.CandidatoService.setCandidato(candidato);
              
              if (!this.CandidatoService.isStricto()) {
                this.CandidatoService.deleteCandidatoCancelado(candidato, cursoSel);
              }

              this.CandidatoService.salvaDadosCandidato(candidato).subscribe(
                (result) => {
                  this.SessionService.setValor(
                    "dadosCandidato",
                    JSON.stringify(result)
                  );

                  this.redirecionar();
                },
                (err) => {
                  if (
                    Number(err.error.code) === 400 &&
                    this.processoService.getMatriculaRedirecionamento()
                  ) {
                    const processo_selecionado = this.processoService.getProcessoSeletivoSelecionado();
                    const curso_selecionado = JSON.parse(
                      this.SessionService.getValor("cursoSelecionado")
                    );

                    const dadosCandidato = {
                      PrcLetAno: processo_selecionado.PrcLetAno,
                      PrcLetSem: processo_selecionado.PrcLetSem,
                      PrcTipCod: this.processoService.getTipoProcesso(),
                      PrcOcoSeq: curso_selecionado.PrcOcoSeq,
                      PrcOfeSeq: curso_selecionado.PrcOfeSeq,
                      PrcCdtEnemNum: candidato.PrcCdtEnemNum,
                      PrcCdtEnemAno: candidato.PrcCdtEnemAno,
                      PrcBolsa: candidato.bolsa,
                      PrcInsCod: candidato.instrumento,
                    };

                    this.SessionService.setValor(
                      "dadosCandidato",
                      JSON.stringify(dadosCandidato)
                    );

                    this.redirecionar();
                  } else {
                    Swal(err.error.message);
                  }
                }
              );
            },
            (err) => console.log(err)
          );
        }

        // const processo: number = this.processoService.getTipoProcesso();

        // if (processo !== 6) {
        //   this.router.navigate(["/ensino-medio"]);

        //   return;
        // }

        // Alteração para processo de enfermagem
        // this.CandidatoService.salvaCandidato(null, null, true, null).subscribe(
        //   (data) => {
        //     let candidato = this.CandidatoService.getCandidato();

        //     candidato.PrcCdtCod = Number(data.SdtPrcCandidato.PrcCdtCod);
        //     candidato.ensino = null;
        //     candidato.conclusao = null;
        //     candidato.concluinte = true;

        //     this.CandidatoService.setCandidato(candidato);

        //     this.CandidatoService.salvaDadosCandidato(candidato).subscribe(
        //       (result) => {
        //         this.SessionService.setValor(
        //           "dadosCandidato",
        //           JSON.stringify(result)
        //         );

        //         this.router.navigate(["/mensagem-final"]);
        //       },
        //       (err) => {
        //         Swal(err.error.message);
        //       }
        //     );
        //   },
        //   (err) => console.log(err)
        // );
      });
  }

  validForm(campo, nome) {
    if (!this.formulario.controls[campo].valid) {
      this.pessoa[campo] = "";
      if (this.formulario.controls[campo].errors["required"]) {
        this[campo + "_classe"] = "classWarning";
        this[campo + "_placeholder"] = nome + " é obrigatório";
      } else {
        this[campo + "_classe"] = "classErro";
        this[campo + "_placeholder"] = nome + " está inválido";
      }
    }
  }

  selecionaPais(pais) {
    this.pessoa.pais_cod = pais;
    this.paises.forEach((element) => {
      if (pais == element.pais_cod) {
        this.pais_selecionado = element.text;
      }
    });
    this.enderecoService.getEstados(pais).subscribe(
      (estados) => this.atualizaCamposEstado(estados),
      (err) => err
    );
  }

  atualizaCamposPais(paises) {
    this.paises = paises;

    if (this.pessoa.pais_cod) {
      let pais_selecionado_obj;
      this.paises.forEach((element) => {
        if (this.pessoa.pais_cod == element.pais_cod) {
          this.pais_selecionado = element.text;
          pais_selecionado_obj = element;
        }
      });
      this.selecionaPais(pais_selecionado_obj.id);
    }
  }

  atualizaCamposEstado(estados) {
    this.estados = estados;
    if (this.pessoa.uf_cod) {
      if (this.estados[this.pessoa.uf_cod]) {
        let estado_selecionado_obj;
        this.estados.forEach((element) => {
          if (this.pessoa.uf_cod == element.uf_cod) {
            this.estado_selecionado = element.text;
            estado_selecionado_obj = element;
          }
        });
        this.selecionaEstado(estado_selecionado_obj);
      }
    }
  }

  selecionaEstado(estado) {
    this.pessoa.pes_end_uf = estado.text;
    this.pessoa.uf_cod = estado.id;

    this.enderecoService.getCidades(estado.id).subscribe(
      (cidades) => this.atualizaCamposCidade(cidades),
      (err) => err
    );
  }

  atualizaCamposCidade(cidades) {
    this.cidades = cidades;
    if (this.pessoa.cid_cod_end) {
      this.cidades.forEach((element) => {
        if (this.pessoa.cid_cod_end == element.cid_cod) {
          this.cidade_selecionado = element.text;
        }
      });
    }
  }

  selecionaCidade(cidade) {
    this.pessoa.pes_end_cid = cidade.text;
    this.pessoa.cid_cod_end = cidade.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/endereco/endereco.component.ts